import { connect } from 'react-redux'

import ServiceCard from './ServiceCard'

const mapStateToProps = ({ services }, { name }) => services[name] || {}

export default connect(mapStateToProps)(ServiceCard)



// WEBPACK FOOTER //
// ./src/Catalog/Service/ServiceCard/ServiceCardContainer.js